import {
  RuntimeStore,
  RuntimeEffect,
  RuntimeEvent,
  RuntimeWatch,
  RuntimeOn,
  RuntimeForward,
  RuntimeSample
} from '../runtime/units'

export function generateEventDefinition({name}: RuntimeEvent) {
  return `const ${name} = createEvent({name: "${name}"})\n`
}
export function generateEffectDefinition({name, handler}: RuntimeEffect) {
  return `const ${name} = createEffect({
  name: "${name}",
  handler: ${handler.toString()}
})\n`
}
export function generateStoreDefinition({name, initialValue}: RuntimeStore) {
  const value = JSON.stringify(initialValue)
  return `const ${name} = createStore(${value}, {name: "${name}"})\n`
}
export function generateWatchDefinition({owner, sources}: RuntimeWatch) {
  return `${owner}.watch(${sources})\n`
}
export function generateOnDefinition({source, clock, sources}: RuntimeOn) {
  return `${source}.on(${clock}, ${sources})\n`
}
export function generateForwardDefinition({source, target}: RuntimeForward) {
  return `forward({from: ${source}, to: ${target}})\n`
}
export function generateSampleDefinition({
  source,
  clock,
  target
}: RuntimeSample) {
  return [
    'sample({',
    `  source: ${source},`,
    `  clock: ${clock},`,
    `  target: ${target}`,
    `})\n`
  ].join(`\n`)
}
